import { render, staticRenderFns } from "./NormalLayout.vue?vue&type=template&id=2a6cea3a&scoped=true&"
import script from "./NormalLayout.vue?vue&type=script&lang=ts&"
export * from "./NormalLayout.vue?vue&type=script&lang=ts&"
import style0 from "./NormalLayout.vue?vue&type=style&index=0&id=2a6cea3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6cea3a",
  null
  
)

export default component.exports